const state = {
	isNewUserModalActive: false,
	isNewOrderModalActive: false,
	isViewUserModalActive: false,
	isViewOrderModalActive: false,
	isViewRouteModalActive: false,
	isEditModeActive: false
}

const actions = {
	showViewOrderModal({ commit }, editMode = false) {
		commit('SHOW_VIEW_ORDER_MODAL', editMode)
	},
	hideViewOrderModal({ commit }) {
		commit('HIDE_VIEW_ORDER_MODAL')
	},
	showViewRouteModal({ commit }) {
		commit('SHOW_VIEW_ROUTE_MODAL')
	},
	hideViewRouteModal({ commit }) {
		commit('HIDE_VIEW_ROUTE_MODAL')
	},
	showNewOrderModal({ commit }) {
		commit('SHOW_NEW_ORDER_MODAL')
	},
	hideNewOrderModal({ commit }) {
		commit('HIDE_NEW_ORDER_MODAL')
	},
	showNewUserModal({ commit }) {
		commit('SHOW_NEW_USER_MODAL')
	},
	hideNewUserModal({ commit }) {
		commit('HIDE_NEW_USER_MODAL')
	},
	showViewUserModal({ commit }) {
		commit('SHOW_VIEW_USER_MODAL')
	},
	hideViewUserModal({ commit }) {
		commit('HIDE_VIEW_USER_MODAL')
	}
}

const mutations = {
	SHOW_VIEW_ORDER_MODAL(state, editMode) {
		state.isViewOrderModalActive = true
		state.isChangeRouteFormVisible = false
		state.isNewRouteFormVisible = false
		state.isEditModeActive = editMode
	},
	HIDE_VIEW_ORDER_MODAL(state) {
		state.isViewOrderModalActive = false
	},
	SHOW_NEW_ORDER_MODAL(state) {
		state.isViewOrderModalActive = true
		state.isEditModeActive = true
	},
	HIDE_NEW_ORDER_MODAL(state) {
		state.isNewOrderModalActive = false
	},
	SHOW_NEW_USER_MODAL(state) {
		state.isNewUserModalActive = true
	},
	HIDE_NEW_USER_MODAL(state) {
		state.isNewUserModalActive = false
	},
	SHOW_VIEW_USER_MODAL(state) {
		state.isViewUserModalActive = true
	},
	HIDE_VIEW_USER_MODAL(state) {
		state.isViewUserModalActive = false
	},
	SHOW_VIEW_ROUTE_MODAL(state) {
		state.isViewRouteModalActive = true
	},
	HIDE_VIEW_ROUTE_MODAL(state) {
		state.isViewRouteModalActive = false
	}
}

export default {
	namespaced: true,
	state,
	actions,
	mutations
}
